<template>
  <div style="display: flex; flex-direction: column">
    <div class="query-bar">
      <el-select
        v-model="query.fState"
        style="width: 120px"
        size="small"
        clearable
      >
        <el-option value="未提交">未提交</el-option>
        <el-option value="已提交">已提交</el-option>
      </el-select>
      <el-input
        v-model="query.fBillNo"
        placeholder="订单编号"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fCkBillNo"
        placeholder="送货单号"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fDistributor"
        placeholder="经销商"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fCustomer"
        placeholder="客户名称"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-input
        v-model="query.fName_sh"
        placeholder="收货人"
        size="small"
        style="width: 200px"
        clearable
      />
      <el-date-picker
        v-model="query.fDate"
        type="date"
        value-format="yyyy-MM-dd"
        placeholder="订单时间"
        size="small"
        style="width: 130px"
      />
      <el-button type="primary" size="small" @click="refresh">查询</el-button>
      <el-button
        type="success"
        size="small"
        @click="confirm"
      >批量确认</el-button>
      <el-button-export :url="downloadUrl" type="primary" size="small">导出</el-button-export>
      <span v-if="monnyNum">金额：{{ monnyNum }}</span>
    </div>
    <div style="flex: auto; display: flex; flex-direction: column;overflow: auto">
      <el-table
        v-loading="loading"
        v-el-table-height-fix
        :data="tableData"
        height="100%"
        @row-dblclick="_view"
        @select="rowSelect"
        @select-all="rowSelect"
      >
        <el-table-column type="selection" width="50" />
        <el-table-column prop="fCkBillNo" label="送货单编号" width="140px" />
        <el-table-column prop="fBillNo" label="订单编号" width="140px" />
        <el-table-column prop="fState" label="单据状态" width="80px" />
        <el-table-column prop="fDistributor" label="经销商" min-width="160px" />
        <el-table-column prop="fCustomer" label="客户名称" min-width="160px" />
        <el-table-column prop="fName_sh" label="收货人" width="80px" />
        <el-table-column prop="fAmount" label="总金额" width="100px" />
        <el-table-column prop="fDate" label="订单时间" width="100px" />
        <el-table-column prop="fPhone" label="电话" width="120px" />
        <el-table-column prop="fAddress_sh" label="地址" min-width="160px" />
        <el-table-column label="操作" width="50px">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="_view(scope.row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-pagination
        :current-page.sync="query.pageIndex"
        :page-size.sync="query.pageSize"
        :page-sizes="[20, 50, 100, 500]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="this.pageRecordTotal"
        @size-change="refresh"
        @current-change="refresh"
      />
    </div>
  </div>
</template>
<script>
import Confirm from './Confirm'
import ConfirmResult from './ConfirmResult'

export default {
  components: {
    Confirm
  },
  data() {
    return {
      query: {
        fState: '未提交',
        fDate: null,
        fName_sh: null,
        fBillNo: null,
        fCkBillNo: null,
        fDistributor: null,
        fBillingName: null,

        pageIndex: 1,
        pageSize: 20
      },
      pageRecordTotal: 0,
      monnyNum: 0,
      tableData: [],
      loading: false,
      currentEditItem: null
    }
  },
  mounted() {
    this.refresh()
  },
  activated() {
    // if (this.$route.query.isrefresh == 'yes') this.refresh()
    // this.$route.query.isrefresh = null
    this.refresh()
  },
  methods: {
    rowSelect: function(selction) {
      this.currentEditItem = selction
      let num = 0
      selction.forEach(val => {
        num += val.fAmount
      })
      const nums = num.toFixed(2)
      nums == 0.00 ? this.monnyNum = num : this.monnyNum = nums
    },
    confirm: function() {
      const items = this.currentEditItem

      if (!items || !items.length) {
        this.$message.warning('请选中要操作的行')
        return
      }

      const h = this.$createElement
      this.$formDlg({
        title: `发票信息`,
        width: '70%',
        formTpl: <Confirm></Confirm>,
        formSubmit: (formData) => {
          return this.$httpPost(
            'BusinessManage/DeliveryForJxs/DeliveryForJxsBatch',
            {
              datalist: JSON.stringify({
                fpInfo: formData,
                idList: items.map((x) => x.fid)
              })
            }
          ).then((res) => {
            // console.log('xxx', res)
            if (!res.isSuccess) {
              this.$message.error(res.message)
              throw res.message
            }

            setTimeout(() => {
              this.$formDlg({
                title: '处理结果',
                width: '30%',
                formTpl: <ConfirmResult form={res.datalist}></ConfirmResult>,
                readonly: true,
                formClose: () => {
                  this.refresh()
                }
              })
            }, 0)
          })
        }
      })
    },
    downloadUrl: function() {
      return this.$buildDownloadUrl(
        'Download/DeliveryJxsDownload',
        this.queryParam(true)
      )
    },
    queryParam: function(forExport) {
      var rtn = {
        ...this.query
      }
      if (forExport) {
        // if (rtn.startGroupNumber == "") rtn.startGroupNumber = null;
        // if (rtn.endGroupNumber == "") rtn.endGroupNumber = null;
        delete rtn.pageIndex
        delete rtn.pageSize
      }
      return rtn
    },
    refresh() {
      this.loading = true
      this.$httpPost(
        'BusinessManage/DeliveryForJxs/DeliveryForJxsEntry',
        this.query
      )
        .then((res) => {
          if (!res.isSuccess) {
            this.$message.error(res.message)
            return
          }
          this.tableData = res.datalist.dataEntry
          this.pageRecordTotal = res.datalist.total
        })
        .finally(() => (this.loading = false))
    },
    _view: async function(row) {
      const readonly = await this.$httpPost('OrderManage/GetBillState', {
        fid: row.fid,
        key: 'DeliveryNote_jxs_q'
      }).then((res) => res.datalist)
      var url = this.$route.path + '/' + (readonly ? 'v/' : '') + row.fid
      this.$router.push(url)
    }
  }
}
</script>
